/** @format */

import React, { Component } from 'react';
import { Menu, Button, Icon } from 'semantic-ui-react';
import { withRouter } from 'react-router-dom';
import './ClientToolbar.css';

import { inject, observer } from 'mobx-react';

@inject('ClientsStore')
@observer
class ClientToolbar extends Component {
  render() {
    const { ClientsStore } = this.props;
    const clientId = ClientsStore.clientsParams.currentClientId;
    return (
      <Menu className="client-toolbar" borderless size="small">
        <Menu.Menu position="right">
          <Menu.Item>
            <Button
              size="small"
              color="orange"
              onClick={() => {
                ClientsStore.resetCurrentClient();
                this.props.history.push('/clients/');
              }}
            >
              <Icon name="arrow left" />
              Indietro
            </Button>
          </Menu.Item>
          <Menu.Item>
            <Button
              size="small"
              color="green"
              onClick={() => ClientsStore.toggleEditClientForm(clientId)}
            >
              <Icon name="edit" />
              Modifica Cliente
            </Button>
          </Menu.Item>
        </Menu.Menu>
      </Menu>
    );
  }
}

export default withRouter(ClientToolbar);
